import * as React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import { Stack, Box } from '@mui/material'

import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import DropDownOA from '../../common/dropDownOA'
import '../../../App.css'
import '../../../css/modal.scss'
import LineInput from '../../common/lineinput'
import { GetActivityUI } from '../../activity'
import { useSearchParams } from 'react-router-dom'
import { Item } from '../../common/snippets'
import Datepicker from '../../common/datePicker'
import {
  Dispatch_From_City,
  Dispatch_From_Branch,
  Receiving_City,
  Receiving_Branch,
  Select_Vehicle,
  Select_Challan,
  BranchReceiv_Consignment_Type,
} from './Lables'
import { updateStrtCity, updateBrnchList, updateStrtBrnch, getBranchList } from '../../../store/common/common_action'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import {
  getUpdateDispatchBranch,
  getUpdateSelectVehicle,
  getUpdateSHowListData,
  updateShowListData,
} from '../../../store/branchTransferReceive/branchReceive_action'
import { clickElement, focusElemnt } from '../../common/helper'
import { API_CACHE_DURATION, Consignmentobj } from '../../common/constants'
const TopSection = ({
  data,
  buttonId,
  setState,
  updateStrtCity,
  updateBrnchList,
  updateStrtBrnch,
  getUpdateDispatchBranch,
  getUpdateSelectVehicle,
  getUpdateSHowListData,

  topSelectedData,
  setTopSelectedData,
  tSecDropData,
  setTSecDropData,
  setSelectedData,
  setShowBtnList,
  showBtnList,
  selectedChallanData,
  setSelectedChallanData,
  selectedVehicleData,
  setSelectedVehicleData,
  handleAlert,
  updateShowListData,
  setChaVehWise
}) => {
  const [searchParams] = useSearchParams()
  const { common, BranchTransferReceiveReducer, delivery } = data
  const { showModal, modalType, alert, strtCity, strtBrnch, cityList, loginData, brnchList, destCity, cnsgnmntTypes } = { ...common }
  const { dispatchBranches, dispatchSelectVehicle } = { ...BranchTransferReceiveReducer }
  const [currentView, setCurrentView] = useState(searchParams.get('view') || common.selectedActvty)
  const [toDayDate, setTodayDate] = useState()
  // console.log(4545,topSelectedData.consignmentData)
  //All State
  const [apiData, setApiData] = useState({
    senCNnST: '',
    isScUpdated: false,
  })
  const { senCNnST, isScUpdated } = apiData
  const [activeClass, setActiveClass] = useState({
    VehicleWise: false,
    ChallanWise: false,
    bkButton: false,
  })
  const { VehicleWise, ChallanWise, bkButton } = activeClass
  const [dataState, setDataState] = useState({
    selectGoDisable: false,
    selectVehicleNo: null,
    GoBtnDes: true,
    challanAllSelect: false,
  })
  const { selectGoDisable, selectVehicleNo, GoBtnDes, challanAllSelect } = dataState

  //All states End

  // console.log(222,selectedChallanData)

  function dateFormat(inputDate, format) {
    //parse the input date
    const date = new Date(inputDate)

    //extract the parts of the date
    const day = date.getDate()
    const month = date.getMonth() + 1
    const year = date.getFullYear()

    //replace the month
    format = format.replace('MM', month.toString().padStart(2, '0'))

    //replace the year
    if (format.indexOf('yyyy') > -1) {
      format = format.replace('yyyy', year.toString())
    } else if (format.indexOf('yy') > -1) {
      format = format.replace('yy', year.toString().substr(2, 2))
    }

    //replace the day
    format = format.replace('dd', day.toString().padStart(2, '0'))

    return format
  }
  function getNumericMonth(monthAbbr) {
    return String(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].indexOf(monthAbbr) + 1).padStart(
      2,
      '0'
    )
  }

  // All UseEffect
  useEffect(() => {
    setActiveClass({ ...activeClass, VehicleWise: true })
  }, [])

  useEffect(() => {
    setSelectedVehicleData([])
    setSelectedVehicleData(dispatchSelectVehicle?.Data || [])
  }, [dispatchSelectVehicle])
  useEffect(() => {
    if (dispatchSelectVehicle.status === 'Success') {
      if (ChallanWise) {
        const filteredData = dispatchSelectVehicle?.Data?.filter((val, i) => val.VoucherNo !== 0)
        setSelectedChallanData([])
        setSelectedChallanData(filteredData)
      }
    }
  }, [dispatchSelectVehicle])
  useEffect(()=>{
    if(loginData.intBranchID){
      getUpdateDispatchBranch(loginData, {}, true, API_CACHE_DURATION)
    }
  },[loginData])
  useEffect(() => {
    const todayDate = new Date().toString().split(' ')
    const year = todayDate[3]
    const day = todayDate[2]
    const month = getNumericMonth(todayDate[1])
    const currentDate = `${year}-${month}-${day}`
    setTodayDate(currentDate)
    clickElement('dispatchBranchReceive')
  }, [])
  // For Str city abd Branch
  useEffect(() => {
    if (cityList.length > 0) {
      const sC = cityList?.find(({ CityID }) => CityID == loginData.intBranchCityID)
      if (sC) {
        updateStrtCity(sC)
        if (!isScUpdated) {
          setApiData({ ...apiData, senCNnST: destCity.CityName + `, ${destCity.StateName}`, isScUpdated: true })
        }
        setApiData({ ...apiData, senCNnST: sC.CityName + `, ${sC.StateName}` })
      }
    }
  }, [cityList])

  useEffect(() => {
    if (brnchList.length > 0) {
      updateStrtBrnch(brnchList.find(({ BranchID }) => BranchID == loginData.intBranchID) || {})
      updateBrnchList(brnchList, 1)
    }
  }, [brnchList])
  // For Str city abd Branch

  //All useEffetct End

  //All onClick
  const onClick = (id, e) => {
    updateShowListData([])
    switch (id) {
      case 'Vehicle':
        setActiveClass({ ...activeClass, VehicleWise: true, ChallanWise: false })
        setDataState({ ...dataState, selectGoDisable: false })
        // setTSecDropData({ ...tSecDropData, SellectedChallanNumber: 'All' })
        clickElement('VehicleNumberBranchReceive')
        setShowBtnList(true)
        setState({ showListTable: false, showListAllTable: false })
        setSelectedChallanData([])
        setChaVehWise(0)
        break
      case 'Challan':
        setState({ showListTable: false, showListAllTable: false })
        setSelectedChallanData([])
        setActiveClass({ ...activeClass, VehicleWise: false, ChallanWise: true, bkButton: false })
        clickElement('VoucherNos')
        setDataState({ ...dataState, selectGoDisable: true })
        const SelectedChallanData = dispatchSelectVehicle?.Data?.filter((val, i) => val.VoucherNo !== 0)
        // SelectedChallanData?.unshift({ VoucherNo: 'All' })
        setSelectedChallanData(SelectedChallanData)
        if (GoBtnDes == false) {
          setShowBtnList(false)
        }
        setChaVehWise(1)
        break
      case 'ShoList':
        if (VehicleWise == true) {
          if (topSelectedData.SelectedVehicle == '') {
            handleAlert('Select Vehicle')
          } else {
            const dtDate = topSelectedData.SelectedVehicle.VehicleWithDetail.split(':')
            const fulldate = dtDate[1].split('-')
            const object = {
              intFromBranchID: topSelectedData.DFromBranch.BranchID,
              intToBranchID: strtBrnch.BranchID,
              strVehicleNo: topSelectedData.SelectedVehicle.VehicleNo,
              intVoucherNo: tSecDropData?.SellectedChallanNumber?.VoucherNo||0 ,
              intVehicleID: topSelectedData.SelectedVehicle.VehicleID,
              dtDate: dateFormat(fulldate, 'yyyy-MM-dd'),
              intConsignmentID: tSecDropData.selectconsignmentType === 'All' ? 0 : tSecDropData.selectconsignmentType.ConsignmentSubTypeID,
            }
            getUpdateSHowListData(loginData, object)
            setSelectedData([])
            setState({ showListTable: true, showListAllTable: false })
          }
        } else {
          if (tSecDropData.SellectedChallanNumber === 'All' || tSecDropData?.SellectedChallanNumber?.VoucherNo === 'All') {
            handleAlert('Select Challan Number')
          } else {
            const object = {
              intFromBranchID: topSelectedData.DFromBranch.BranchID,
              intToBranchID: strtBrnch.BranchID,
              strVehicleNo: '',
              intVoucherNo: tSecDropData?.SellectedChallanNumber?.VoucherNo || 0,
              intVehicleID: 0,
              dtDate: toDayDate,
              intConsignmentID: tSecDropData.selectconsignmentType === 'All' ? 0 : tSecDropData.selectconsignmentType.ConsignmentSubTypeID,
            }
            getUpdateSHowListData(loginData, object)
            setSelectedData([])
            setState({ showListTable: true, showListAllTable: false })
          }
        }
        break
      case 'ShoListAll':
        if (VehicleWise == true) {
          if (topSelectedData.SelectedVehicle == null) {
            handleAlert('Select Vehicle')
          } else {
            setSelectedData([])
            const dtDate = topSelectedData.SelectedVehicle.VehicleWithDetail.split(':')
            const fulldate = dtDate[1].split('-')

            const object = {
              intFromBranchID: topSelectedData.DFromBranch.BranchID,
              intToBranchID: strtBrnch.BranchID,
              strVehicleNo: topSelectedData.SelectedVehicle.VehicleNo,
              intVoucherNo: tSecDropData?.SellectedChallanNumber?.VoucherNo || 0,
              intVehicleID: topSelectedData.SelectedVehicle.VehicleID,
              dtDate: dateFormat(fulldate, 'yyyy-MM-dd'),
              intConsignmentID: tSecDropData.selectconsignmentType === 'All' ? 0 : tSecDropData.selectconsignmentType.ConsignmentSubTypeID,
            }
            getUpdateSHowListData(loginData, object)
            setState({ showListTable: true, showListAllTable: true })
          }
        } else {
          if (tSecDropData.SellectedChallanNumber === 'All' || tSecDropData?.SellectedChallanNumber?.VoucherNo === 'All') {
            handleAlert('Select Challan Number')
          } else {
            setSelectedData([])
            const object = {
              intFromBranchID: topSelectedData.DFromBranch.BranchID,
              intToBranchID: strtBrnch.BranchID,
              strVehicleNo: '',
              intVoucherNo: tSecDropData?.SellectedChallanNumber?.VoucherNo || 0,
              intVehicleID: 0,
              dtDate: toDayDate,
              intConsignmentID: tSecDropData.selectconsignmentType === 'All' ? 0 : tSecDropData.selectconsignmentType.ConsignmentSubTypeID,
            }
            getUpdateSHowListData(loginData, object)
            setState({ showListTable: true, showListAllTable: true })
          }
        }
        break
      case 'firstGoBTN':
        if (VehicleWise == true) {
          const obj = {
            FromBranchID: topSelectedData?.DFromBranch?.BranchID,
            intToCityID: strtBrnch.BranchID,
          }
          getUpdateSelectVehicle(loginData, obj)
          setDataState({ ...dataState, GoBtnDes: false })
          clickElement('VehicleNumberBranchReceive')
        } else {
          const obj = {
            FromBranchID: topSelectedData?.DFromBranch?.BranchID,
            intToCityID: strtBrnch.BranchID,
          }
          getUpdateSelectVehicle(loginData, obj)
          clickElement('VoucherNos')
          setDataState({ ...dataState, GoBtnDes: true })
        }
        if (ChallanWise == true) {
          setShowBtnList(false)
        }
        break
      case 'secondGoBTN':
        const filteredData = dispatchSelectVehicle?.Data?.filter((val, i) => val.VehicleWithDetail === topSelectedData.SelectedVehicle.VehicleWithDetail)
        // console.log(filteredData)
        const slectedData = filteredData?.filter((val) => val.VoucherNo !== 0)
        setDataState({ ...dataState, GoBtnDes: false })
        setSelectedChallanData([])
        // slectedData?.unshift({ VoucherNo: 'All' })
        setSelectedChallanData(slectedData)
        clickElement('VoucherNos')
        setShowBtnList(false)
        break
      default:
        break
    }
  }

  const onKeyDown = (e, id) => {
    if (e.key === 'Escape') {
      switch (id) {
        case 'firstGo':
          focusElemnt('dispatchBranchReceive')
          break
        case 'showlist':
          focusElemnt(BranchReceiv_Consignment_Type)
          break
        case 'secondGo':
          focusElemnt('VehicleNumberBranchReceive')
          break
        default:
          break
      }
    } else if (e.key === 'Enter') {
      // setState({ showListTable: true })
      switch (id) {
        case 'showlist':
          focusElemnt('checkbox_0')
          break
        default:
          break
      }
    }
  }

  return (
    <>
      <Stack
        direction="row"
        divider={
          <Divider
            orientation="vertical"
            sx={{
              width: '2px',
              margin: '14px -16px 0px 0px !important',
              backgroundColor: '#0086ff',
            }}
            flexItem
          />
        }
        spacing={2}
        sx={{ background: '#FFF' }}
      >
        <Item sx={{ width: '100%', paddingBottom: '0px', paddingTop: '16px' }}>
          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              display: 'inline-flex',
              padding: '0% 10px',
            }}
          >
            {GetActivityUI(currentView)}
            <Item sx={{ width: '100%' }}>
              <DropDownOA
                type={Dispatch_From_City}
                defaultvalue={strtCity.CityName || ''}
                data={cityList || []}
                width="100%"
                searchPlaceholder={`Search ${Dispatch_From_City}`}
                label={'Transfer From City'}
                disabled
                tabIndex="2"
              />
            </Item>
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              display: 'inline-flex',
              padding: '0% 10px',
            }}
          >
            <Item sx={{ width: '50%' }}>
              <div className="input--container date-picker" style={{ width: '100%' }}>
                <Datepicker
                  className="deliver-date-picker"
                  name={'filter_from_dt'}
                  type="filter_from_dt"
                  statusChecked={true}
                  label="Receive Date"
                  disabled
                />
              </div>
            </Item>
            <Item sx={{ width: '50%', paddingBottom: '0px', display: 'flex' }}>
              <DropDownOA
                // key={`select_consigner`}
                type={Dispatch_From_Branch}
                label={'Transfer From Branch'}
                data={dispatchBranches.Data || []}
                width="100%"
                searchPlaceholder={'Search Branch Name'}
                isObjArr={true}
                dataKey={`BranchName`}
                idKey={`BranchID`}
                id="dispatchBranchReceive"
                nextId="firstGoBTNBranchReceive"
                prevId="activitytype"
                setAllValue={setTopSelectedData}
                allValues={topSelectedData}
                defaultvalue={topSelectedData.resetData ? ' ' : ''}
              />
              {/* <span>hii</span> */}
              <Button
                variant="contained"
                id="firstGoBTNBranchReceive"
                disabled={topSelectedData.DFromBranch == null ? true : false}
                style={{
                  width: '10%',
                  height: '37px',
                  marginLeft: '7px',
                  backgroundColor: topSelectedData.DFromBranch == null ? '#cccccc' : '#fe5200',
                  fontSize: '15px',
                  textTransform: 'Uppercase',
                  color: '#fff',
                  fontWeight: 'bold',
                }}
                onClick={() => onClick('firstGoBTN')}
                onKeyDown={(e) => onKeyDown(e, 'firstGo')}
              >
                GO
              </Button>
            </Item>

            <Item
              sx={{
                width: '50px',
                display: 'inline-flex',
                padding: '0% 5px',
                height: '50px',
                marginLeft: '-48px !Important',
                marginRight: '0px !Important',
              }}
            >
              <div
                style={{
                  position: 'relative',
                  top: '4px',
                  left: '45px',
                  border: '3px solid white',
                  height: '40px',
                  width: '40px',
                  background: '#0086ff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%',
                  color: 'white',
                }}
              >
                <ArrowForwardIcon />
              </div>
            </Item>
          </Box>

          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              display: 'inline-flex',
              padding: '0% 10px',
            }}
          >
            <Item sx={{ width: '25%' }}>
              <Button
                id={buttonId}
                sx={{
                  // width: "49%",
                  // display: "flex",
                  justifyContent: 'start',
                  // alignItems: "center",
                  border: VehicleWise ? '2px solid #0086ff' : '1px solid grey',
                  // margin: "9px",
                  // height: "39px",
                  cursor: 'pointer',
                  width: '100%',
                }}
                autoFocus={true}
                onClick={() => onClick('Vehicle')}
              >
                <LineInput type="radio" checked={VehicleWise} autoFocus={VehicleWise} />

                <span
                  // id={buttonId}
                  style={{
                    fontSize: '14px',
                    paddingLeft: '8px',
                    fontWeight: '500',
                    color: 'black',
                    border: '0px',
                    textTransform: 'none',
                  }}
                >
                  Vehicle Wise
                </span>
              </Button>
            </Item>
            <Item sx={{ width: '25%' }}>
              <Button
                id={buttonId}
                sx={{
                  // width: "49%",
                  // display: "flex",
                  justifyContent: 'start',
                  // alignItems: "center",
                  border: ChallanWise ? '2px solid #0086ff' : '1px solid grey',
                  // margin: "9px",
                  // height: "39px",
                  cursor: 'pointer',
                  width: '100%',
                }}
                autoFocus={true}
                onClick={() => onClick('Challan')}
              >
                <LineInput type="radio" checked={ChallanWise} />

                <span
                  // id={buttonId}
                  style={{
                    fontSize: '14px',
                    paddingLeft: '8px',
                    fontWeight: '500',
                    color: 'black',
                    border: '0px',
                    textTransform: 'none',
                  }}
                >
                  Challan Wise
                </span>
              </Button>
            </Item>
            <Item sx={{ width: '50%', paddingBottom: '0px', display: 'flex' }}>
              <DropDownOA
                // key={`select_consigner`}
                label={Select_Vehicle}
                data={selectedVehicleData || []}
                width="100%"
                searchPlaceholder={'Search Vehicle Number'}
                isObjArr={true}
                dataKey={`VehicleWithDetail`}
                idKey={`VehicleWithDetail`}
                id="VehicleNumberBranchReceive"
                nextId="secondGoBTNBranchReceive"
                prevId="firstGoBTNBranchReceive"
                onSelect={(val) => setTopSelectedData({ ...topSelectedData, SelectedVehicle: val, changeFromBranch: false })}
                defaultvalue={topSelectedData.resetData || topSelectedData.changeFromBranch || ChallanWise ? ' ' : ''}
                disabled={selectGoDisable}
                value={topSelectedData.SelectedVehicle?.VehicleWithDetail || ''}
              />
              {/* <span>hii</span> */}
              <Button
                variant="contained"
                disabled={selectGoDisable || topSelectedData.SelectedVehicle == '' ? true : false}
                id="secondGoBTNBranchReceive"
                style={{
                  width: '10%',
                  height: '37px',
                  marginLeft: '7px',
                  backgroundColor: selectGoDisable || topSelectedData.SelectedVehicle == '' ? '#cccccc' : '#fe5200',
                  fontSize: '15px',
                  textTransform: 'Uppercase',
                  color: '#fff',
                  fontWeight: 'bold',
                }}
                onClick={() => onClick('secondGoBTN')}
                onKeyDown={(e) => onKeyDown(e, 'secondGo')}
              >
                GO
              </Button>
            </Item>
          </Box>
        </Item>
        <Item sx={{ width: '100%', paddingBottom: '0px', paddingTop: '16px' }}>
          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              display: 'inline-flex',
              padding: '0% 10px',
            }}
          >
            <Item sx={{ width: '100%' }}>
              <DropDownOA
                type={Receiving_City}
                defaultvalue={strtCity.CityName || ''}
                data={cityList || []}
                width="100%"
                searchPlaceholder={`Search ${Receiving_City}`}
                label={Receiving_City}
                disabled
                tabIndex="2"
              />
            </Item>
            <Item sx={{ width: '100%' }}>
              <DropDownOA
                type={BranchReceiv_Consignment_Type}
                // defaultvalue={}
                defaultvalue={topSelectedData.resetData ? 'All' : 'All'}
                data={[Consignmentobj, ...cnsgnmntTypes] || []}
                width="100%"
                searchPlaceholder={`Search ${BranchReceiv_Consignment_Type}`}
                label={BranchReceiv_Consignment_Type}
                portal={true}
                isObjArr={true}
                dataKey={`SubType`}
                idKey={`ConsignmentSubTypeID`}
                setAllValue={setTSecDropData}
                allValues={tSecDropData}
                id={BranchReceiv_Consignment_Type}
                prevId="VoucherNos"
                nextId="showListBranchReceive"
              />
            </Item>
          </Box>

          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              display: 'inline-flex',
              padding: '0% 10px',
            }}
          >
            <Item sx={{ width: '100%', paddingBottom: '0px' }}>
              <DropDownOA
                type={Receiving_Branch}
                defaultvalue={strtBrnch.BranchName || ''}
                width="100%"
                searchPlaceholder={`Search ${Receiving_Branch}`}
                label={Receiving_Branch}
                disabled
              />
            </Item>
            <Item sx={{ width: '100%' }}>
              <Button
                onClick={(e) => onClick('ShoList', e)}
                variant="contained"
                sx={{ width: '100%' }}
                style={{
                  backgroundColor: showBtnList == true ? '#cccccc' : '#fe5200',
                  fontSize: '15px',
                  textTransform: 'Uppercase',
                  color: '#fff',
                  fontWeight: 'bold',
                }}
                disabled={showBtnList}
                id="showListBranchReceive"
                onKeyDown={(e) => onKeyDown(e, 'showlist')}
              >
                {' '}
                SHOW LIST
              </Button>
            </Item>
          </Box>

          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              display: 'flex',
              padding: '0% 10px',
            }}
          >
            <Item sx={{ width: '100%', paddingBottom: '0px' }}>
              <DropDownOA
                defaultvalue={tSecDropData.SellectedChallanNumber == undefined ? ' ' : tSecDropData?.SellectedChallanNumber?.VoucherNo}
                data={selectedChallanData || []}
                width="100%"
                searchPlaceholder={`Search ${Select_Challan}`}
                label={Select_Challan}
                portal={false}
                isObjArr={false}
                dataKey={`VoucherNo`}
                idKey={`VoucherNo`}
                id="VoucherNos"
                nextId={BranchReceiv_Consignment_Type}
                prevId="secondGoBTNBranchReceive"
                onSelect={(val) => {
                  setTSecDropData({ ...tSecDropData, SellectedChallanNumber: val })
                  setTopSelectedData({ ...topSelectedData, SelectedVehicle: val, changeFromBranch: false })
                }}
              />
            </Item>

            <Item sx={{ width: '100%' }}>
              <Button
                variant="contained"
                sx={{ width: '100%' }}
                style={{
                  backgroundColor: showBtnList == true ? '#cccccc' : '#fe5200',
                  fontSize: '15px',
                  textTransform: 'Uppercase',
                  color: '#fff',
                  fontWeight: 'bold',
                }}
                onClick={(e) => onClick('ShoListAll', e)}
                disabled={showBtnList}
                id="showListAllBranchReceive"
              >
                SHOW LIST ALL
              </Button>
            </Item>
          </Box>
        </Item>
      </Stack>
    </>
  )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
  updateStrtCity,
  updateBrnchList,
  updateStrtBrnch,
  getBranchList,
  getUpdateDispatchBranch,
  getUpdateSelectVehicle,
  getUpdateSHowListData,
  updateShowListData
}

export default connect(mapStateToProps, mapDispatchToProps)(TopSection)
